import { call, put, takeLatest } from 'redux-saga/effects';
import { Map, List } from 'immutable';
import { Notification } from '@utils';
import {
  getTarefas as getTarefasSdk,
  getTarefa as getTarefaSdk,
  postTarefa as postTarefaSdk,
  putTarefa as putTarefaSdk,
} from '@sdk/Conectores/Tarefas';

//Action Types
export const Types = {
  GET_TAREFAS: 'GET_TAREFAS',
  GET_TAREFAS_SUCCESS: 'GET_TAREFAS_SUCCESS',
  GET_TAREFAS_ERROR: 'GET_TAREFAS_ERROR',

  GET_TAREFA: 'GET_TAREFA',
  GET_TAREFA_SUCCESS: 'GET_TAREFA_SUCCESS',
  GET_TAREFA_ERROR: 'GET_TAREFA_ERROR',

  POST_TAREFA: 'POST_TAREFA',
  POST_TAREFA_SUCCESS: 'POST_TAREFA_SUCCESS',
  POST_TAREFA_ERROR: 'POST_TAREFA_ERROR',

  PUT_TAREFA: 'PUT_TAREFA',
  PUT_TAREFA_SUCCESS: 'PUT_TAREFA_SUCCESS',
  PUT_TAREFA_ERROR: 'PUT_TAREFA_ERROR',

  RESET_TAREFAS: 'RESET_TAREFAS',
};

//Action Creators
export const getTarefas = (idConfiguracao, idFonteDado) => ({ type: Types.GET_TAREFAS, idConfiguracao, idFonteDado });
export const getTarefasSuccess = (data) => ({ type: Types.GET_TAREFAS_SUCCESS, data });
export const getTarefasError = (error) => ({ type: Types.GET_TAREFAS_ERROR, error });

export const getTarefa = (idConfiguracao, idFonteDado, id) => ({ type: Types.GET_TAREFA, idConfiguracao, idFonteDado, id });
export const getTarefaSuccess = (data) => ({ type: Types.GET_TAREFA_SUCCESS, data });
export const getTarefaError = (error) => ({ type: Types.GET_TAREFA_ERROR, error });

export const postTarefa = (data) => ({ type: Types.POST_TAREFA, data });
export const postTarefaSuccess = () => ({ type: Types.POST_TAREFA_SUCCESS });
export const postTarefaError = (error) => ({ type: Types.POST_TAREFA_ERROR, error });

export const putTarefa = (data) => ({ type: Types.PUT_TAREFA, data });
export const putTarefaSuccess = () => ({ type: Types.PUT_TAREFA_SUCCESS });
export const putTarefaError = (error) => ({ type: Types.PUT_TAREFA_ERROR, error });

export const reset = () => ({ type: Types.RESET_TAREFAS });

//saga
function* fetchGetTarefas(action) {
  try {
    const { idConfiguracao, idFonteDado } = action;
    const tarefas = yield call(getTarefasSdk, idConfiguracao, idFonteDado);
    yield put(getTarefasSuccess(tarefas));
  } catch (err) {
    Notification.error(err.message);
    yield put(getTarefasError(err));
  }
}

function* fetchGetTarefa(action) {
  try {
    const { idConfiguracao, idFonteDado, id } = action;
    const tarefa = yield call(getTarefaSdk, idConfiguracao, idFonteDado, id);
    yield put(getTarefaSuccess(tarefa));
  } catch (err) {
    Notification.error(err.message);
    yield put(getTarefaError(err));
  }
}

function* fetchPostTarefa(action) {
  try {
    const { data } = action;
    yield call(postTarefaSdk, data);
    yield put(postTarefaSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(postTarefaError(err));
  }
}

function* fetchPutTarefa(action) {
  try {
    const { data } = action;
    yield call(putTarefaSdk, data);
    yield put(putTarefaSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(putTarefaError(err));
  }
}

export const saga = [
  takeLatest(Types.GET_TAREFAS, fetchGetTarefas),
  takeLatest(Types.GET_TAREFA, fetchGetTarefa),
  takeLatest(Types.POST_TAREFA, fetchPostTarefa),
  takeLatest(Types.PUT_TAREFA, fetchPutTarefa),
];

// Reducer
const initialState = Map({
  tarefas: List(),
  tarefa: {},

  loadingTarefas: false,
  successTarefas: false,
  errorTarefas: false,

  loadingTarefa: false,
  successTarefa: false,
  errorTarefa: false,

  postingTarefa: false,
  successPostTarefa: false,
  errorPostTarefa: false,

  putingTarefa: false,
  successPutTarefa: false,
  errorPutTarefa: false,
});

const handleGetTarefas = (state, action) => {
  return state.set('loadingTarefas', false).set('successTarefas', false).set('errorTarefas', false);
};

const handleGetTarefasSuccess = (state, action) => {
  const tarefas = action.data;

  return state.set('tarefas', List(tarefas)).set('loadingTarefas', false).set('successTarefas', true).set('errorTarefas', false);
};

const handleGetTarefasError = (state, action) => {
  return state.set('loadingTarefas', false).set('successTarefas', false).set('errorTarefas', action.error);
};

const handleGetTarefa = (state, action) => {
  return state.set('loadingTarefa', false).set('successTarefa', false).set('errorTarefa', false);
};

const handleGetTarefaSuccess = (state, action) => {
  const tarefa = action.data[0];
  return state.set('tarefa', tarefa).set('loadingTarefa', false).set('successTarefa', true).set('errorTarefa', false);
};

const handleGetTarefaError = (state, action) => {
  return state.set('loadingTarefa', false).set('successTarefa', false).set('errorTarefa', action.error);
};

const handlePostTarefa = (state, action) => {
  return state.set('postingTarefa', false).set('successPostTarefa', false).set('errorPostTarefa', false);
};

const handlePostTarefaSuccess = (state, action) => {
  return state.set('postingTarefa', false).set('successPostTarefa', true).set('errorPostTarefa', false);
};

const handlePostTarefaError = (state, action) => {
  return state.set('postingTarefa', false).set('successPostTarefa', false).set('errorPostTarefa', action.error);
};

const handlePutTarefa = (state, action) => {
  return state.set('putingTarefa', false).set('successPutTarefa', false).set('errorPutTarefa', false);
};

const handlePutTarefaSuccess = (state, action) => {
  return state.set('putingTarefa', false).set('successPutTarefa', true).set('errorPutTarefa', false);
};

const handlePutTarefaError = (state, action) => {
  return state.set('putingTarefa', false).set('successPutTarefa', false).set('errorPutTarefa', action.error);
};

const handleReset = (state, action) => {
  state = initialState;
  return state;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_TAREFAS:
      return handleGetTarefas(state, action);
    case Types.GET_TAREFAS_SUCCESS:
      return handleGetTarefasSuccess(state, action);
    case Types.GET_TAREFAS_ERROR:
      return handleGetTarefasError(state, action);

    case Types.GET_TAREFA:
      return handleGetTarefa(state, action);
    case Types.GET_TAREFA_SUCCESS:
      return handleGetTarefaSuccess(state, action);
    case Types.GET_TAREFA_ERROR:
      return handleGetTarefaError(state, action);

    case Types.POST_TAREFA:
      return handlePostTarefa(state, action);
    case Types.POST_TAREFA_SUCCESS:
      return handlePostTarefaSuccess(state, action);
    case Types.POST_TAREFA_ERROR:
      return handlePostTarefaError(state, action);

    case Types.PUT_TAREFA:
      return handlePutTarefa(state, action);
    case Types.PUT_TAREFA_SUCCESS:
      return handlePutTarefaSuccess(state, action);
    case Types.PUT_TAREFA_ERROR:
      return handlePutTarefaError(state, action);

    case Types.RESET_TAREFAS:
      return handleReset(state, action);

    default:
      return state;
  }
}
